import React from "react";

import { ICellRendererParams } from "ag-grid-community";

import Badge from "components/Badge";

import { MasterRuleStatus, MasterRuleStatusTooltip } from "constants/rules";

import { AgriNousLogo } from "img/AgriNousActiveLogo";
import { AggridColDefContext } from "lib/agGrid/types";

export const StatusRenderer = (
  props: ICellRendererParams<unknown, string>,
): React.JSX.Element | null => {
  const { value, node, colDef } = props;
  if (!value) {
    return null;
  }

  // If it is grouped, we need to pull out the statusRenderProps a different way
  const rowGroupColDefContext: AggridColDefContext | undefined =
    node?.rowGroupColumn?.getColDef()?.context;
  const colDefContext: AggridColDefContext | undefined = colDef?.context;

  const accessor =
    rowGroupColDefContext?.statusRendererProps ??
    colDefContext?.statusRendererProps;

  const { colorMap = {} } = accessor || {};
  return <Badge color={colorMap[value]}>{value.replace(/_/g, " ")}</Badge>;
};

export function RuleSyncStatusRenderer(
  props: ICellRendererParams<unknown, MasterRuleStatus>,
): React.JSX.Element | null {
  const { data, value: status } = props;

  if (!data) {
    return null;
  }
  const { color, backgroundColor } = MasterRuleStatusTooltip[status];

  return (
    <AgriNousLogo
      backgroundColor={backgroundColor}
      color={color}
      scale={0.4}
      size={25}
    />
  );
}
